module.exports = __webpack_public_path__ + "static/img/2.af05295.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/sp/2.png
// module id = XUUm
// module chunks = 0